import { useMemo } from "react";
import useElectionsData from "../../hooks/useElectionsData";

function WinnerStyles() {
  const electionsData = useElectionsData();
  const winnerStyles = useMemo(() => {
    let styles = "";
    const winnerUrls: Record<string, string> = {};
    electionsData.sheetData.forEach((sheetDataPoint) => {
      if (winnerUrls[sheetDataPoint.winner]) return;
      winnerUrls[sheetDataPoint.winner] = sheetDataPoint["URL"];
    });
    Object.keys(winnerUrls).forEach((winner) => {
      styles += `
        .us-elections-widget__winner-avatar[title="${winner}"] {
          background-image: url(${winnerUrls[winner]});
        }
      `;
    });
    return styles;
  }, [electionsData]);

  return <style>{winnerStyles}</style>;
}

export default WinnerStyles;
